export default {
    id: "svetofore-ru-domain-2026",
    articleType: "release",
    slug: "svetofore-ru-russkiy-domen",
    date: "3 марта 2026",
    dateTime: "2026-03-03",
    modifiedTime: "2026-03-03",
    author: "Редакция «Светофор Логистика»",
    category: "Обновления платформы · 2026",
    contentType: "Обновление",
    title: "«Светофор Логистика» добавила российский домен svetofore.ru",
    sidebarTitle: "Российский домен svetofore.ru",
    seoTitle:
        "«Светофор Логистика» доступна на российском домене svetofore.ru",
    seoDescription:
        "Платформа «Светофор Логистика» получила российский домен svetofore.ru. Личные кабинеты, функциональность и пользовательские данные остались прежними.",
    image: "/img/news/svetofore-ru-russkiy-domen/cover.webp",
    imageAlt:
        "Переход от домена svetofore.com к российскому домену svetofore.ru",
    content: {
        subtitle: "Платформа получила российский адрес svetofore.ru",
        lead: [
            "У «Светофор Логистика» появился российский домен svetofore.ru. Он дополнил использовавшийся ранее адрес в зоне .com и сделал адрес платформы привычнее для российского рынка.",
        ],
        sections: [
            {
                icon: "🇷🇺",
                title: "Что изменилось",
                paragraphs: [
                    "Пользователи получили дополнительный адрес для входа на платформу — svetofore.ru.",
                    "Сегодня именно svetofore.ru используется как основной публичный домен «Светофор Логистика».",
                ],
            },
            {
                icon: "🔐",
                title: "Что осталось прежним",
                paragraphs: [
                    "Функциональность платформы, личные кабинеты и пользовательские данные не изменились. Обновление затронуло адрес доступа, а не рабочие сценарии пользователей.",
                ],
            },
        ],
        action: {
            href: "https://svetofore.ru",
            label: "Перейти на svetofore.ru",
            external: true,
        },
    },
};
